<template>
  <div v-if="ads.length" class="gs-section">
    <div class="gs-section__toolbar">
      <p class="gs-section__count">{{ countLabel }}</p>
    </div>

    <div class="gs-asset-grid gs-asset-grid--wide">
      <asset-card v-for="ad in ads" :key="ad.id" collapsible :title="ad.name">
        <template slot="preview">
          <pre class="gs-asset-text">{{ ad.copy }}</pre>
        </template>

        <template slot="default">
          <div class="gs-fb-ad__block">
            <p class="gs-asset-label">{{ $t('frontend_resources_suggested_interests') }}</p>
            <ul v-if="interestsOf(ad).length" class="gs-asset-chips">
              <li v-for="(interest, index) in interestsOf(ad)" :key="index" class="gs-asset-chip">
                {{ interest }}
              </li>
            </ul>
            <p v-else class="gs-section__note">No suggested interests for this ad.</p>
          </div>

          <div class="gs-fb-ad__block">
            <p class="gs-asset-label">{{ $t('frontend_resources_ad_images') }}</p>
            <ul v-if="ad.images && ad.images.length" class="gs-asset-thumbs">
              <li v-for="(image, imageIndex) in ad.images" :key="imageIndex" class="gs-asset-thumb">
                <img :src="image" :alt="`${ad.name} ${imageIndex + 1}`" />
                <a
                  class="gs-button gs-button--outline gs-button--sm gs-download"
                  :href="image"
                  :download="`${ad.name}-${imageIndex + 1}`"
                  target="_blank"
                  rel="noopener"
                  title="Download this ad image"
                >
                  <gs-icon name="download" size="14" />
                  Download
                </a>
              </li>
            </ul>
            <p v-else class="gs-section__note">{{ $t('frontend_resources_no_ad_images') }}</p>
          </div>
        </template>

        <template slot="actions">
          <copy-button
            :text="ad.copy"
            label="Copy ad copy"
            :title="$t('frontend_affiliate_promo_copy_fb_ad')"
          />
          <copy-button
            v-if="ad.interests"
            :text="ad.interests"
            label="Copy interests"
            :title="$t('frontend_resources_suggested_interests')"
          />
        </template>
      </asset-card>
    </div>
  </div>

  <div v-else class="gs-empty">
    <span class="gs-empty__icon"><gs-icon name="star" size="22" /></span>
    <p class="gs-empty__title">{{ $t('frontend_resources_no_facebook_ads') }}</p>
    <p class="gs-empty__text">Ad copy, targeting ideas and creatives show up here.</p>
  </div>
</template>

<script>
import AssetCard from '@/components/promotools/AssetCard.vue';
import CopyButton from '@/components/promotools/CopyButton.vue';

export default {
  components: {
    AssetCard,
    CopyButton,
  },
  props: {
    funnelResource: {
      type: Object,
      required: true,
    },
  },
  computed: {
    ads() {
      return (this.funnelResource && this.funnelResource.facebook_ads
        ? this.funnelResource.facebook_ads.filter(ad => ad.enabled)
        : []);
    },
    countLabel() {
      const count = this.ads.length;
      return `${count} ${count === 1 ? 'ad' : 'ads'}`;
    },
  },
  methods: {
    // Vendors type interests as a comma or line separated list; chips make the
    // list scannable while "Copy interests" still hands over the raw string.
    interestsOf(ad) {
      return (ad.interests || '')
        .split(/[,\n]/)
        .map(interest => interest.trim())
        .filter(interest => interest);
    },
  },
};
</script>

<style scoped>
.gs-fb-ad__block {
  display: flex;
  flex-direction: column;
  gap: 8px;
  min-width: 0;
}
</style>
